import { useMemo } from 'react';

// @mui
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function useResponsive(query, start, end) {
  const theme = useTheme();

  const breakpoint = useMemo(() => {
    if (query === 'up') return theme.breakpoints.up(start);
    if (query === 'down') return theme.breakpoints.down(start);
    if (query === 'between') return theme.breakpoints.between(start, end);

    return theme.breakpoints.only(start);
  }, [query, start, end, theme]);

  return useMediaQuery(breakpoint);
}

export function useWidth() {
  const theme = useTheme();

  const keys = [...theme.breakpoints.keys].reverse();

  return (
    keys.reduce((output, key) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useMediaQuery(theme.breakpoints.up(key));

      return !output && matches ? key : output;
    }, null) || 'xs'
  );
}
